<template>
  <div class="prodcut">
    <div class="question-title">
      <div style="display: flex;">
        <span>
          是否实体卡
        </span>

        <span class="question-title-require">
          *
        </span>
      </div>
    </div>
    <div class="prodcut-type">
      <van-radio-group
        v-model="totalInfo.card_type"
        direction="horizontal"
        @change="emitChange"
      >
        <van-radio :name="0">是（实体卡）</van-radio>
        <van-radio :name="1">否（电子卡）</van-radio>
      </van-radio-group>
    </div>
    <div class="question-title">
      <div style="display: flex;">
        <span>
          {{ question.label }}
        </span>

        <span class="question-title-require">
          *
        </span>
      </div>
    </div>
    <div
      class="prodcut-box"
      v-for="(address, addressIndex) in answerList"
      :key="address.index"
    >

      <div class="prodcut-box-title">
        <span>
          {{ totalInfo.card_type == 0 ? '地址' : '邮箱' }}{{ address.index }}
        </span>
        <el-button
          type="danger"
          icon="el-icon-close"
          size="mini"
          @click="delAddress(address, addressIndex)"
        >删除</el-button>
      </div>
      <van-field
        v-model="address.address"
        name="address"
        label=""
        :placeholder="totalInfo.card_type == 0 ? '实体卡请填写：收货信息(收件人、电话、地址 )' : '电子卡请填写：收货人邮箱地址'"
        type="textarea"
        rows="3"
        @input="emitChange"
      />
      <div
        class="prodcut-box"
        v-for="(prodcut, prodcutIndex) in address.products"
        :key="prodcut.prodcutIndex"
      >

        <div class="prodcut-box-title">
          <span>
            产品{{ prodcut.prodcutIndex }}
          </span>
          <el-button
            type="danger"
            icon="el-icon-close"
            size="mini"
            @click="delProduct(address, prodcutIndex)"
          >删除</el-button>
        </div>
        <van-form>

          <van-field
            readonly
            clickable
            name="picker"
            :value="prodcut.name"
            label="产品名称"
            placeholder="点击选择产品名称"
            @click="showProdcutPicker(prodcut)"
          />
          <van-popup
            v-model="showPicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="columns"
              value-key="name"
              @confirm="onProdcutConfirm"
              @cancel="showPicker = false"
            >
              <template v-slot:option="option">

                <div @click="onProdcutConfirm(option)">
                  {{ option.name }}
                </div>
              </template>

            </van-picker>
          </van-popup>
          <van-field
            v-model="prodcut.price"
            name="渠道价"
            label="渠道价"
            placeholder=""
            :disabled="true"
          />
          <van-field
            v-model="prodcut.num"
            name="数量"
            label="数量"
            type="digit"
            placeholder="请填写数量"
            @input="priceChange(prodcut)"
          />
          <van-field
            :value="prodcut.total"
            name="总价"
            label="总价"
            placeholder=""
            :disabled="true"
          />

        </van-form>
      </div>
      <el-button
        size="small"
        @click="addProduct(address)"
      >新增产品</el-button>
    </div>
    <el-button
      class="add-address"
      size="small"
      @click="addAddress"
    >新增地址</el-button>
    <van-form>

      <van-field
        v-model="totalInfo.total_num"
        name="总数量"
        label="总数量"
        type="digit"
        placeholder=""
        :disabled="true"
      />
      <van-field
        :value="totalInfo.total_price"
        name="总金额"
        label="总金额"
        placeholder=""
        :disabled="true"
      />

    </van-form>
  </div>
</template>

<script>
import mixins from "./mixins";
import { Message } from "element-ui";
import { deepClone } from "@/utils/utils.js";
import workService from "@/apis/work/index.js";
let index = 1;
const prodcutIndex = 1;
const newAddress = {
  prodcutIndex,
  index,
  products: [
    {
      prodcutIndex: `1-1`,
    },
  ],
};

export default {
  name: "product",
  mixins: [mixins],
  data() {
    return {
      answerList: [
        {
          index: 1,
          ...deepClone(newAddress),
        },
      ],
      answer: {},
      showPicker: false,
      columns: [],
      total: "",
      totalInfo: {
        card_type: 0,
      },
      currentProduct: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    const { question } = this;
    this.columns = JSON.parse(question.datasource);
  },
  methods: {
    emitChange() {
      const { answerList, totalInfo } = this;
      this.answerChange({
        data: [...answerList],
        ...totalInfo,
      });
    },
    // 新增地址
    addAddress() {
      index++;
      newAddress.products[0].prodcutIndex = `${index}-1`;
      this.answerList.push({
        ...deepClone(newAddress),
        index,
      });
      this.emitChange();
    },
    // 新增产品
    addProduct(address) {
      address.prodcutIndex++;
      address.products.push({
        prodcutIndex: `${address.index}-${address.prodcutIndex}`,
      });
      this.emitChange();
    },
    // 删除产品
    delProduct(address, prodcutIndex) {
      if (address.products.length === 1) {
        Message({
          message: "至少保留一个产品",
          type: "warning",
        });
        return;
      }
      address.products.splice(prodcutIndex, 1);
      this.emitChange();
    },
    // 删除地址
    delAddress(address, addressIndex) {
      const { answerList } = this;
      if (answerList.length === 1) {
        Message({
          message: "至少保留一个地址",
          type: "warning",
        });
        return;
      }
      answerList.splice(addressIndex, 1);
      this.emitChange();
    },
    async computedTotal(item) {
      const { totalInfo } = this;

      if (item.price && item.num) {
        item.total = item.price * item.num;
      } else {
        item.total = "";
      }
      totalInfo.total_num = 0;
      totalInfo.total_price = 0;

      this.answerList.forEach((address) => {
        address.products.forEach((prodcut) => {
          if (Number.isFinite(prodcut.total)) {
            totalInfo.total_price += prodcut.total;
            totalInfo.total_num += Number(prodcut.num);
          }
        });
      });
      this.$forceUpdate();
      this.emitChange();
    },
    priceChange(item) {
      this.computedTotal(item);
    },

    showProdcutPicker(item) {
      // 选择产品前先选择二级机构
      const levelInfo = this.getLevelInfo();
      if (!levelInfo.level2) {
        Message({
          message: "请先选择二级机构",
          type: "warning",
        });
        return;
      }
      this.currentProduct = item;
      this.showPicker = true;
    },
    async onProdcutConfirm(item) {
      const { currentProduct } = this;

      currentProduct.id = item.id;
      currentProduct.name = item.name;
      currentProduct.price = item.price;
      currentProduct.local_price = item.price;
      const remotePrice = await this.getProductPriceByChannel(item);
      currentProduct.price = remotePrice.price || currentProduct.local_price;
      if (remotePrice.price === -1) {
        currentProduct.price = 0;
      }

      this.showPicker = false;
      this.computedTotal(currentProduct);
    },
    async pickerClick(option) {
      console.log(option);
      const { currentProduct } = this;
      currentProduct.id = option.id;
      currentProduct.name = option.name;
      currentProduct.price = option.price;
      currentProduct.local_price = option.price;
      const remotePrice = await this.getProductPriceByChannel(currentProduct);
      currentProduct.price = remotePrice.price || currentProduct.local_price;
      if (remotePrice.price === -1) {
        currentProduct.price = 0;
      }
      this.showPicker = false;

      this.computedTotal(currentProduct);
    },

    getLevelInfo() {
      let level1 =
          this.getQuestionListByFieldId("channel_and_level2")?.answer
            ?.channel || "",
        level2 =
          this.getQuestionListByFieldId("channel_and_level2")?.answer?.org ||
          "",
        level3 = this.getQuestionListByFieldId("level3")?.answer || "",
        level4 = this.getQuestionListByFieldId("level4")?.answer || "";
      return {
        level1,
        level2,
        level3,
        level4,
      };
    },
    getProductPriceByChannel(product) {
      const levelInfo = this.getLevelInfo();

      const params = {
        ...levelInfo,
        product_id: product.id,
      };
      return workService.getProductPriceByChannel(params);
    },
    onLevelChange() {
      const levelInfo = this.getLevelInfo();
      const { answerList } = this;
      if (levelInfo.level2) {
        answerList.forEach((answer) => {
          answer.products.forEach(async (product) => {
            if (product.id) {
              const remotePrice = await this.getProductPriceByChannel(product);
              product.price = remotePrice.price || product.local_price;
              if (remotePrice.price === -1) {
                product.price = 0;
              }
              this.computedTotal(product);
            }
          });
        });
      }
    },
    // change(value) {
    //   this.answerChange(value)
    // },
  },
};
</script>

<style lang="scss" scoped>
.prodcut {
  .el-button {
    width: 100%;
    margin-top: 10px;
  }
  .add-address {
    margin-bottom: 20px;
  }
}
.prodcut-box {
  border: 1px solid #dcdfe6;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  .van-cell {
    border: none;
  }
}
.prodcut-box-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button {
    width: 70px;
  }
}
.prodcut-type {
  margin-bottom: 10px;
}
</style>